
import {Component, Vue} from 'vue-property-decorator';
import {CfQuery} from "@/api/priceclass/types";
import {cfPage, changeCfStatus} from "@/api/priceclass";
import Pagination from "@/components/Pagination/index.vue";
import CfForm from "./CfForm.vue";

@Component({
  name: "CfDetail",
  components: {
    Pagination,
    CfForm,
  }
})
export default class CfDetail extends Vue {
  private searchForm = [
    {
      label: "系数名称",
      prop: "name",
      key: "name",
      type: "input",
      value: null,
      placeholder: "请输入系数名称"
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [
        {
          desc: '使用中',
          name: 'true'
        },
        {
          desc: '弃用',
          name: 'false'
        },
        {
          desc: '全部',
          name: null
        }
      ],
      resetKey: {label: "desc", value: "name"},
    }
  ]

  private searchFormObject: CfQuery = {
    name: null,
    status: null,
    pcId: null,
  };

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [],
  };

  private handleSearch(data) {
    this.table.pageNumber = 1;
    this.searchFormObject = data && data !== "reset" ? {
      ...this.searchFormObject,
      ...data
    } : {
      ...this.searchFormObject,
      name: null,
      status: null,
    };
    this.getList();
  }

  private async getList() {
    const {total, content}: any = await cfPage(this.searchFormObject, {
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize
    });

    this.table.total = total;
    this.table.list = content;
  }

  private detailTableCol = [
    {
      label: "S/N",
      prop: "id",
      key: "sn",
      type: 'input',
      show: true,
      disabled: false,
    },
    {
      label: "系数名称",
      prop: "name",
      key: "name",
      show: true,
      disabled: false,
    },
    {
      label: "系数",
      prop: "value",
      key: "value",
      show: true,
      disabled: false,
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      show: true,
      disabled: false,
      render: (value) => {
        if (value) {
          return '使用中'
        }
        return '弃用'
      },
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "编辑",
          code: "",
          click: "handleEdit"
        },
        {
          name: "启用",
          code: "",
          click: "handleEnable",
          show: row => {
            return !row.status
          }
        },
        {
          name: "弃用",
          code: "",
          click: "handleUnable",
          show: row => {
            return row.status
          }
        }
      ],
      show: true,
      disabled: false,
      width: 260,
    }
  ] as any;

  private className = '';
  private showClassName = false;

  private handleEdit({row}) {
    (this.$refs['cfForm'] as CfForm).show(row)
  }

  private handleEnable({row}) {
    this.$confirm("确认启用？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      return changeCfStatus(this.searchFormObject.pcId, row.id, true)
    }).then(() => {
      this.handleConfirm();
    }).catch(() => {
      console.log('取消');
    });
  }

  private handleUnable({row}) {
    this.$confirm("确认弃用？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      return changeCfStatus(this.searchFormObject.pcId, row.id, false)
    }).then(() => {
      this.handleConfirm();
    }).catch(() => {
      console.log('取消');
    });
  }

  private handleConfirm() {
    this.getList();
    this.$emit('confirm')
  }


  public show(row) {
    this.className = row.name
    this.searchFormObject.pcId = row.id
    this.showClassName = true
    this.getList();
  }
}
